<template>
    <modal closeMutation="SET_SHOP_PAYMENT_MODAL">
        <div class="modal_shop_payment-header">
            Оплата
        </div>

        <div v-if="atmosWait.active" class="modal_shop_payment-atmos-wait">
            <span v-if="!atmosWait.timedOut" class="modal_shop_payment-atmos-spinner"></span>
            <p v-if="!atmosWait.timedOut">Оплата открыта в новой вкладке. Ожидаем результат…</p>
            <p v-else>Не удалось подтвердить оплату. Если вы уже оплатили в открытой вкладке, проверьте статус ещё раз.</p>
            <button type="button" class="modal_shop_payment-btn btn btn-square btn-full" @click="retryAtmosCheck">
                Проверить оплату ещё раз
            </button>
            <button v-if="atmosWait.timedOut" type="button" class="modal_shop_payment-atmos-cancel" @click="reopenAtmosTab">
                Открыть страницу оплаты ещё раз
            </button>
            <button type="button" class="modal_shop_payment-atmos-cancel" @click="cancelAtmosWait">
                Отменить
            </button>
        </div>

        <form v-else class="modal_shop_payment-form" @submit.prevent="">

            <div class="select_field" :class="{ active: paymentSelectOpen }" tabindex="1" @blur="paymentSelectOpen = false">
                <div class="select_value" @click="paymentSelectOpen = !paymentSelectOpen">

                    <div class="payment_value" v-if="this.form.payment_type !== null">
                        <div class="payment_value-logo" v-if="paymentIconSrc(form.payment_type.icon)">
                            <img :src="paymentIconSrc(form.payment_type.icon)" alt="">
                        </div>
                        <div class="payment_value-name">
                            {{this.form.payment_type.label}}
                        </div>
                        <div class="payment_value-param" v-if="this.form.payment_type.card !== undefined">
                            *{{this.form.payment_type.card.CardLastFour}}
                        </div>
                    </div>

                    <div class="select_arrow">
                        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.72326 6.00005L0.332733 1.60953C0.0723832 1.34918 0.0723833 0.927066 0.332733 0.666717C0.593082 0.406367 1.01519 0.406367 1.27554 0.666717L6.60888 6.00005L1.27554 11.3334C1.01519 11.5937 0.593082 11.5937 0.332733 11.3334C0.0723832 11.073 0.0723832 10.6509 0.332733 10.3906L4.72326 6.00005Z" fill="#3C67D6"/>
                        </svg>
                    </div>
                </div>
                <div class="select_items">
                    <div
                        class="select_item"
                        v-for="(option, i) of paymentTypes"
                        :key="i"
                        @click="
                          form.payment_type = option;
                          paymentSelectOpen = false;
                        "
                        :class="{active: form.payment_type === option}"
                    >
                        <div class="payment_value">
                            <div class="payment_value-logo" v-if="paymentIconSrc(option.icon)">
                                <img :src="paymentIconSrc(option.icon)">
                            </div>
                            <div class="payment_value-name">
                                {{ option.label }}
                            </div>
                            <div class="payment_value-param" v-if="option.card !== undefined">
                                *{{ option.card.CardLastFour }}
                            </div>
                        </div>

                        <div class="select_item-active" v-if="form.payment_type === option">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="24 / basic / check-mark">
                                    <path id="icon" fill-rule="evenodd" clip-rule="evenodd" d="M6.47173 9.52876L12.667 3.3335L13.6098 4.27631L6.47173 11.4144L2.66699 7.60964L3.6098 6.66683L6.47173 9.52876Z" fill="#3C67D6"/>
                                </g>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>

            <div class="promocode_field" :class="{'promocode-error': ((promocodeData.success) === false)}">
                <input
                    type="text"
                    placeholder="Промокод"
                    v-model.trim="form.promocode"
                >
                <div class="promocode_field-accept" @click="checkPromocode">
                    Применить
                </div>
                <div class="promocode_field-error" v-if="promocodeData.error !== null">
                    {{ promocodeData.error }}
                </div>
            </div>

            <input
                v-if="!showYandexPaySplitWidget"
                type="email"
                placeholder="Электронная почта для чека"
                v-model.trim="form.email"
            >

            <div class="bonus_field" v-if="clubSettings?.modules?.balance?.enable">
                <div class="bonus_field-value">
                    {{this.depositData.value}} фитрублей
                    <small>Оплатить бонусами <currency-symbol :price="this.usableDeposit"/></small>
                </div>
                <div class="bonus_field-control">
                    <Toggle v-model="form.useDeposit" />
                </div>
            </div>

            <div class="total_field">
                <div class="total_field-row" v-if="this.promocodeData.success && this.usablePromocode.value !== 0">
                    <div class="key discount">
                        Скидка по промокоду
                    </div>
                    <div class="value red">
                        -<currency-symbol :price="this.usablePromocode"/>
                    </div>
                </div>
                <div class="total_field-row" v-if="this.form.useDeposit && this.usableDeposit.value !== 0">
                    <div class="key discount">
                        Фитрубли
                    </div>
                    <div class="value red">
                        -<currency-symbol :price="this.usableDeposit"/>
                    </div>
                </div>
                <div class="total_field-row">
                    <div class="key">
                        Итого
                    </div>
                    <div class="value">
                        <currency-symbol :price="this.priceTotal"/>
                    </div>
                </div>
            </div>


            <div class="monthly_select" v-if="itemType === 'contract' && durationType=='monthly'">
                <label class="monthly_select-label">Месяц активации</label>
                <div class="select_field" :class="{ active: monthlySelectOpen }" tabindex="1" @blur="monthlySelectOpen = false">
                    <div class="select_value" @click="monthlySelectOpen = !monthlySelectOpen">
                        <div class="payment_value" v-if="form.select_monthly">
                            <div class="payment_value-name">
                                {{ monthSelectedLabel }}
                            </div>
                        </div>

                        <div class="select_arrow">
                            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.72326 6.00005L0.332733 1.60953C0.0723832 1.34918 0.0723833 0.927066 0.332733 0.666717C0.593082 0.406367 1.01519 0.406367 1.27554 0.666717L6.60888 6.00005L1.27554 11.3334C1.01519 11.5937 0.593082 11.5937 0.332733 11.3334C0.0723832 11.073 0.0723832 10.6509 0.332733 10.3906L4.72326 6.00005Z" fill="#3C67D6"/>
                            </svg>
                        </div>
                    </div>
                    <div class="select_items">
                        <div
                            class="select_item"
                            v-for="(opt, i) in monthOptions"
                            :key="i"
                            @click="form.select_monthly = opt.value; monthlySelectOpen = false;"
                            :class="{active: form.select_monthly === opt.value}"
                        >
                            <div class="payment_value">
                                <div class="payment_value-name">
                                    {{ opt.label }}
                                </div>
                            </div>

                            <div class="select_item-active" v-if="form.select_monthly === opt.value">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g id="24 / basic / check-mark">
                                        <path id="icon" fill-rule="evenodd" clip-rule="evenodd" d="M6.47173 9.52876L12.667 3.3335L13.6098 4.27631L6.47173 11.4144L2.66699 7.60964L3.6098 6.66683L6.47173 9.52876Z" fill="#3C67D6"/>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <YandexPaySplitWidget
                v-if="showYandexPaySplitWidget"
                :amount="priceTotal.value"
                :currency="priceTotal.currency"
            />

            <button
                type="submit"
                class="modal_shop_payment-btn btn btn-square btn-full"
                :class="{disabled: isDisabledBtn}"
                @click="submitPayment">
                Оплатить <currency-symbol :price="this.priceTotal"/>
            </button>

            <button
                type="submit"
                class="modal_shop_payment-btn modal_shop_payment-btn_defer btn btn-square btn-full"
                :class="{disabled: isDisabledBtn}"
                v-if="itemCredit"
                @click="submitCredit">
                Купить в рассрочку
            </button>
        </form>

        <div class="modal_shop_payment-hint" v-if="itemReccurent && !atmosWait.active">
            *По подписке первый месяц спишется <currency-symbol :price="this.priceTotal"/>,
            далее будет списываться <currency-symbol :price="this.item.data.reccurent.price"/> в месяц
        </div>

        <div class="modal_shop_payment-hint" v-if="!atmosWait.active">
            Нажимая на кнопку, Вы соглашаетесь с <a :href="this.$store.getters.settings.modules.offer.link" target="_blank">Договором оферты</a>
        </div>

        <div class="modal_shop_payment-errors" v-if="errors.length !== 0 && !atmosWait.active">
            <ul>
                <li v-for="error in errors" :key="error">
                    {{ error }}
                </li>
            </ul>
        </div>
    </modal>
</template>

<script>
    import Modal from "../../views/Modal";
    import Toggle from '@vueform/toggle'
    import CurrencySymbol from "../CurrencySymbol";
    import YandexPaySplitWidget from "../YandexPaySplitWidget";
    import api from "../../api";
    import {
        atmosRedirectPay,
        checkInvoiceWithRetry,
        cloudPaymentsPayWidget,
        createAtmosTabWaiter,
        getPaymentReturnUrl,
        openAtmosPopupTab,
        PAYMENT_SCOPE_PERSONAL_ACCOUNT,
        payselectionPayWidget,
        startYandexPayRedirect,
        tipTopPayWidget,
        yooKassaPayWidget
    } from "../../utilities"
    import {useToast} from "vue-toastification";

    export default {
        name: "ShopModalPayment",
        components: {Modal, Toggle, CurrencySymbol, YandexPaySplitWidget},
        data() {
            return {
                apiKey: '',
                item: this.$store.getters.shopPaymentModal,
                form: {
                    payment_type : null,
                    promocode : '',
                    email: '',
                    useDeposit: false,
                    select_monthly: null,
                },
                promocodeData: {
                    success: null,
                    error: null
                },
                depositData: this.$store.getters.userDeposit,
                cards: [],
                paymentTypes: [],
                paymentSelectOpen: false,
                monthlySelectOpen: false,
                errors: [],
                isDisabledBtn: false,
                monthOptions: [],
                purchasedItemId: null,
                atmosWait: { active: false, timedOut: false },
            }
        },
        setup() {
          const toast = useToast();
          return { toast }
        },
        computed: {
            itemId: function () {
                return this.item.data.id
            },
            itemType: function () {
                return this.item.item_type
            },
            durationType: function () {
                return this.item.data.duration_type
            },
            itemName: function () {
                return this.item.data.name
            },
            itemReccurent: function () {
                if (this.itemType === 'contract'){
                    return this.item.data.reccurent.enable === true ? 1 : null
                }else{
                    return null
                }
            },
            itemCredit: function(){
                if (this.item.data.credit !== undefined && this.$store.getters.settings.modules.payment_types.credit_tinkoff !== undefined){
                    return this.item.data.credit.enable && this.$store.getters.settings.modules.payment_types.credit_tinkoff.enable
                }else{
                    return null
                }
            },
            price: function () {
                return !this.priceSale ? this.item.data.price_full : this.priceSale
            },
            priceSale: function () {
                return this.item.data.sale_price != undefined ? this.item.data.sale_price : null
            },
            priceFull: function () {
                return this.item.data.price_full
            },
            usablePromocode: function(){
                return this.promocodeData.discount_amount !== undefined ? this.promocodeData.discount_amount : null
            },
            usableDeposit: function(){
                const promocodeDiscount = this.promocodeData.success && this.usablePromocode
                    ? Number(this.usablePromocode.value || 0)
                    : 0
                const priceAfterPromocode = Math.max(Number(this.price.value || 0) - promocodeDiscount, 0)
                const maxDeposit = Math.max(priceAfterPromocode - (this.itemReccurent ? 1 : 0), 0)

                return {
                    value: Math.min(Number(this.depositData.value || 0), maxDeposit),
                    currency: this.price.currency
                }
            },
            priceTotal: function () {
                let totalPrice = this.price.value

                if (this.form.useDeposit){
                    totalPrice = totalPrice - this.usableDeposit.value
                }

                if (this.usablePromocode){
                    totalPrice = totalPrice - this.usablePromocode.value
                }

                if (totalPrice < 0){
                    totalPrice = 0
                }

                return {'value': totalPrice, 'currency': this.price.currency}
            },
            clubSettings: function () {
              try {
                console.log(this.$store.getters.settings);
                return this.$store.getters.settings;
              } catch (e) {
                return null
              }
            },
            monthSelectedLabel: function () {
                    const found = this.monthOptions.find(m => m.value === this.form.select_monthly);
                    return found ? found.label : '';
            },
            showYandexPaySplitWidget: function () {
                const paymentSettings = this.$store.getters.settings?.modules?.payment_types
                if (paymentSettings?.online?.acquiring_integration_type !== 'yandex_pay') {
                    return false
                }

                return this.form.payment_type?.method !== 'cash'
            },
        },
        methods: {
            buildMonthOptions() {
                const opts = [];
                const now = new Date();
                for (let i = 0; i <= 3; i++) {
                    const d = new Date(now.getFullYear(), now.getMonth() + i, 1);
                    const yyyy = d.getFullYear();
                    const mm = String(d.getMonth() + 1).padStart(2, '0');
                    const value = `${yyyy}-${mm}-01`;
                    const monthName = new Intl.DateTimeFormat('ru-RU', { month: 'long' }).format(d);
                    const label = monthName.charAt(0).toUpperCase() + monthName.slice(1);
                    opts.push({ value, label });
                }
                this.monthOptions = opts;
                if (!this.form.select_monthly && opts.length > 0) {
                    this.form.select_monthly = opts[0].value;
                }
            },
            async getApiKey() {
                try {
                    this.apiKey = (await this.$api.payment.getApiKey()).data
                } catch (error) {
                    this.errorHandler(error)
                }
            },
            async getCards() {
                try  {
                    this.cards = (await this.$api.payment.getCards()).data
                    this.getPaymentTypes()
                } catch (error) {
                    this.errorHandler(error)
                }
            },
            getPaymentTypes() {
                let paymentTypes = [];
                let settings = this.$store.getters.settings.modules.payment_types ?? false;
                const integrationType = settings?.online?.acquiring_integration_type;

                if (settings) {
                    if (settings.online.enable){
                        // Яндекс Пэй на данный момент не поддерживает привязку карт — сохранённые карты не показываем
                        if (integrationType !== 'yandex_pay') {
                            this.cards.forEach(item => {
                                paymentTypes.push({
                                    'method': 'card',
                                    'label': item.CardType,
                                    'icon': item.CardType,
                                    'card': item
                                })
                            })
                        }
                        paymentTypes.push({
                            'method': 'new_card',
                            'label': 'Новая карта',
                            'icon': 'new_card'
                        })
                    }
                    if (settings.offline.enable && !this.itemReccurent){
                        paymentTypes.push({
                            'method': 'cash',
                            'label': 'Наличные',
                            'icon': 'cash'
                        })
                    }
                }

                this.paymentTypes = paymentTypes
                this.form.payment_type = this.paymentTypes[0]
            },
            async checkPromocode() {
                try {
                    const result = (await api.payment.promocode({
                        params: {
                            promocode: this.form.promocode,
                            service_id: this.itemType === 'service' ? this.itemId : null,
                            contract_id: this.itemType === 'contract' ? this.itemId : null
                        }
                    })).data;

                    this.promocodeData = result
                    this.form.useDeposit = false
                }catch (error) {
                    this.errorHandler(error)
                }
            },
            async addItem() {
                const scheduleId = this.$route.params.scheduleId || this.item.schedule_id || null;
                let item;
                if (this.itemType === 'contract') {
                    item = (await this.$api.contract.addContract({
                        id: this.itemId,
                        deposit: this.form.useDeposit === true ? this.usableDeposit.value : null,
                        promocode: this.promocodeData.success === true ? this.form.promocode : null,
                        recurrent: this.itemReccurent,
                        schedule_id: scheduleId,
                        select_monthly: this.form.select_monthly,
                    })).data;
                } else if (this.itemType === 'service') {
                    item = (await this.$api.service.addService({
                        id: this.itemId,
                        deposit: this.form.useDeposit === true ? this.usableDeposit.value : null,
                        promocode: this.promocodeData.success === true ? this.form.promocode : null,
                        schedule_id: scheduleId,
                    })).data;
                }

                this.purchasedItemId = item.client_contract_id || item.client_service_id || null

                if (this.form.payment_type.method === 'cash' || item.debt_item === undefined) {
                    this.showSuccess(this.form.payment_type.method)
                    return false
                }

                return item
            },
            async createInvoice(debt_item) {
                const acquiringIntegrationType = this.$store.getters.settings.modules.payment_types.online.acquiring_integration_type;
                // ATMOS: withoutLink=0 нужен только для оплаты новой (непривязанной) картой по ссылке — для
                // оплаты уже привязанной картой (method === 'card') pay-link не нужен и создавать его нельзя:
                // его invoice_id пересекается с invoice_id последующего chargeToken() ("-1 Внутренняя ошибка").
                const isAtmosLinkPayment = acquiringIntegrationType === 'atmos' && this.form.payment_type.method !== 'card';
                return (await this.$api.payment.createInvoice({
                    orders: debt_item.id,
                    savecard: 1,
                    email: this.form.email,
                    cloudcheck: 1,
                    withoutLink: isAtmosLinkPayment ? 0 : 1,
                    returnUrl: getPaymentReturnUrl(),
                })).data;
            },
            async pay(invoiceId, amount, currency, JsonData = {}, atmosPopup = null) {
                let paymentMethod = this.form.payment_type.method;
                let payResult, checkResult = false;
                let paymentData;

                if (paymentMethod === 'card') {
                    paymentData = (await this.$api.payment.pay({
                        invoice_id: invoiceId,
                        card_id: this.form.payment_type.card.id
                    })).data;
                    payResult = (paymentData.success === true);
                } else if (paymentMethod === 'new_card') {
                    const settings = this.$store.getters.settings.modules.payment_types.online.acquiring_integration_type ?? false;
                    if (settings === 'cloud_payments') {
                        payResult = await cloudPaymentsPayWidget(
                            this.apiKey,
                            invoiceId,
                            amount,
                            currency,
                            this.$store.getters.userId,
                            this.form.email,
                            JsonData
                        );
                    } else if (settings === 'payselection') {
                        payResult = await payselectionPayWidget(
                            invoiceId,
                            amount,
                            currency,
                            this.$store.getters.userId,
                            this.form.email,
                            JsonData
                        );
                    } else if (settings === 'tip_top_pay') {
                        console.log('tiptop widget init');
                        payResult = await tipTopPayWidget(
                            invoiceId,
                            amount,
                            currency,
                            this.$store.getters.userId,
                            this.form.email,
                            JsonData
                        );
                    } else if (settings === 'yookassa') {
                        payResult = await yooKassaPayWidget(
                            invoiceId,
                            JsonData
                        );
                    } else if (settings === 'yandex_pay') {
                        return startYandexPayRedirect(JsonData, {
                            scope: PAYMENT_SCOPE_PERSONAL_ACCOUNT,
                            invoiceId,
                            shop: {
                                name: this.itemName,
                                price: this.priceTotal,
                                method: this.getSuccessMethod(paymentMethod),
                                itemType: this.itemType,
                                purchasedItemId: this.purchasedItemId,
                                scheduleId: this.item.schedule_id || null,
                            },
                        });
                    } else if (settings === 'atmos') {
                        const atmosResult = atmosRedirectPay(invoiceId, JsonData, atmosPopup);
                        if (!atmosResult) {
                            return false;
                        }
                        if (atmosResult.mode === 'redirect') {
                            return 'redirect';
                        }
                        return await this.atmosWaiter.start(
                            atmosResult.popup,
                            () => this.$api.payment.checkInvoice({ params: { save_card: 1, invoiceId } }),
                            JsonData.paymentLink
                        );
                    } else {
                        console.log('unknown payment method - ', settings);
                        payResult = false;
                    }
                }

                if (payResult) {
                    checkResult = await checkInvoiceWithRetry(this.$api, invoiceId, 1)
                }

                return checkResult
            },
            async retryAtmosCheck() {
                const result = await this.atmosWaiter.retry();
                if (result) {
                    this.showSuccess(this.getSuccessMethod(this.capturedPaymentMethod || 'new_card'));
                }
            },
            cancelAtmosWait() {
                this.atmosWaiter.cancel();
                this.isDisabledBtn = false;
            },
            reopenAtmosTab() {
                this.atmosWaiter.reopen();
            },
            async submitPayment() {
                this.isDisabledBtn = true
                this.errors = []

                const acquiringIntegrationTypeAtClick = this.$store.getters.settings?.modules?.payment_types?.online?.acquiring_integration_type
                const willOpenAtmosTab = this.form.payment_type?.method === 'new_card' && acquiringIntegrationTypeAtClick === 'atmos'
                const atmosPopup = willOpenAtmosTab ? openAtmosPopupTab() : null
                let atmosPopupHandedOff = false

                try {
                    const newItem = await this.addItem();
                    if (newItem.status !== 'success') {
                        this.errors.push('Не удалось провести оплату. Попробуйте еще раз.')
                        this.isDisabledBtn = false
                        return false
                    }

                    const invoice = await this.createInvoice(newItem.debt_item)
                    if (invoice.invoiceId === undefined) {
                        this.errors.push('Не удалось провести оплату. Попробуйте еще раз.')
                        this.isDisabledBtn = false
                        return false
                    }

                    this.capturedPaymentMethod = this.form.payment_type.method
                    atmosPopupHandedOff = true
                    const pay = await this.pay(
                        invoice.invoiceId,
                        newItem.debt_item.full_sum.value,
                        newItem.debt_item.full_sum.currency,
                        invoice.paymentLink ? { paymentLink: invoice.paymentLink } : invoice.JsonData,
                        atmosPopup
                    );
                    if (pay === 'redirect') {
                        return
                    }
                    if (pay === false) {
                        if (!this.atmosWait.active) {
                            this.errors.push('Не удалось провести оплату. Попробуйте еще раз.')
                            this.isDisabledBtn = false
                        }
                        return false
                    }

                    this.showSuccess(this.getSuccessMethod(this.capturedPaymentMethod))
                } catch (error) {
                    this.isDisabledBtn = false
                    console.log(error)
                    this.errorHandler(error)

                    if (error.response && error.response.data && error.response.data.message) {
                      this.toast.error(error.response.data.message);
                    } else if (error.message) {
                      this.toast.error(error.message);
                    } else {
                      this.toast.error('Произошла ошибка. Попробуйте еще раз.');
                    }
                } finally {
                    if (atmosPopup && !atmosPopupHandedOff) {
                        try {
                            atmosPopup.close()
                        } catch (e) {
                            console.log('failed to close unused atmos tab', e)
                        }
                    }
                }
            },
            async submitCredit(){
                this.isDisabledBtn = true
                this.errors = []
                try {
                    const newItem = await this.addItem();
                    if (newItem.status !== 'success'){
                        this.errors.push('Не удалось провести оплату. Попробуйте еще раз.')
                        this.isDisabledBtn = false
                        return false
                    }

                    const invoice = await this.createInvoice(newItem.debt_item)
                    if (invoice.invoiceId === undefined){
                        this.errors.push('Не удалось провести оплату. Попробуйте еще раз.')
                        this.isDisabledBtn = false
                        return false
                    }

                    window.open(this.$store.getters.systemUrl+'/payment/credit?invoice_id='+invoice.invoiceId+'&client_id='+this.$store.getters.userId);

                    this.showSuccess('credit')
                }catch (error) {
                    this.isDisabledBtn = false
                    console.log(error)
                    this.errorHandler(error)
                }
            },
            async showSuccess(paymentMethod){
                this.$store.commit('SET_SHOP_SUCCESS_MODAL', {'name': this.itemName, 'price': this.priceTotal, 'method': paymentMethod})
                this.$store.commit('SET_SHOP_PAYMENT_MODAL', false)
                this.$store.commit('SET_SHOP_ITEM_CONTRACT_MODAL', false)
                this.$store.commit('SET_SHOP_ITEM_SERVICE_MODAL', false)

                if (this.itemType === 'contract'){
                    this.$store.dispatch('loadContracts')
                }else{
                    this.$store.dispatch('loadServices')
                }

                this.$store.dispatch('loadUser')

                if (this.item.schedule_id && this.purchasedItemId) {
                    const params = this.itemType === 'contract'
                        ? { client_contract_id: this.purchasedItemId }
                        : { client_service_id: this.purchasedItemId }
                    try {
                        const resp = await this.$api.schedule.postRegistration(this.item.schedule_id, params)
                        const status = resp.data?.status
                        this.$store.commit('SET_SCHEDULE_REGISTRATION_RESULT', {
                            scheduleId: this.item.schedule_id,
                            success: true,
                            message: status === 'waiting' ? 'Вы добавлены в лист ожидания!' : 'Вы записаны!',
                        })
                    } catch (e) {
                        this.$store.commit('SET_SCHEDULE_REGISTRATION_RESULT', {
                            scheduleId: this.item.schedule_id,
                            success: false,
                            message: 'Покупка прошла успешно, но запись не удалась. Повторите попытку записи',
                        })
                    }
                }
            },
            paymentIconSrc(icon) {
                const known = ['cash', 'maestro', 'mastercard', 'mir', 'new_card', 'sbp', 'union', 'visa']
                const lc = (icon || '').toLowerCase().replace(/\s+/g, '_')
                const found = known.find(k => k === lc || lc.includes(k))
                return require('../../assets/img/payment_types/' + (found || 'new_card') + '.png')
            },
            getSuccessMethod(method) {
                // Success-модалка различает только 'cash' и 'credit'; для онлайн-оплаты
                // (картой / новой картой) показываем общий текст об успешной оплате.
                return method === 'cash' || method === 'credit' ? method : 'card'
            },
            errorHandler(data){
                if (data.error){
                    this.form.errors = data.error;
                }else if (data.response !== undefined && data.response.status !== 200){
                    this.form.errors = new Array(data.response.data.message);
                }
                this.isDisabledBtn = false
            },

        },
        created() {
            this.capturedPaymentMethod = null
            this.atmosWaiter = createAtmosTabWaiter({
                setState: (next) => { this.atmosWait = next }
            })
        },
        mounted() {
            this.getApiKey()
            this.getCards()
            this.getPaymentTypes()
            this.buildMonthOptions();
            this.form.email = this.$store.getters.userEmail
        },
        unmounted() {
            this.atmosWaiter.cancel()
        },
    }
</script>

<style src="@vueform/toggle/themes/default.css"></style>
